/**
 * Shared helper for triggering a browser download from an in-memory Blob
 * (e.g. one fetched from a server-side CSV export endpoint via
 * apiClient.downloadBlob). Same client-side trigger mechanism the app
 * already used for locally-generated CSVs — just now handed a real
 * server response instead of a client-built string.
 */
export function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
